import type { ContentPack, RulesOptions } from '@bcm/rules';
import pack from '../generated/content-pack.json' with { type: 'json' };

export const contentPack = pack as unknown as ContentPack;

/** Rules options for a named preset ('v2' = defaults; 'v1' = the original ruleset for A/B). */
export function presetOptions(name: string): Partial<RulesOptions> {
  if (name === 'v2' || name === 'default') return {};
  const p = contentPack.presets[name];
  if (!p) throw new Error(`Unknown preset "${name}". Known: v2, ${Object.keys(contentPack.presets).join(', ')}`);
  return p;
}

export * from '../generated/ids.js';
